export default function tmpOrderReducer(state, action) {
    //console.log('STATE  : ', state)
    switch (action.type) {
      case 'GET_ALL_TMP_ORDERS':
        return {
          ...state,
          tmpOrders: action.payload,
          loading: false,
        }
      case 'ADD_TMP_ORDER':
        console.log("reducer", state, action.payload)
        return {
          ...state,
          tmpOrders: [action.payload, ...state.tmpOrders],
        }
      default:
        return state
    }
  }
  